import { makeStyles } from "@material-ui/core/styles";

import { colors } from "@utils/constant";

const ConsignmentStyle = makeStyles((theme) => ({
  ConsignmentWrapper: {
    "& .MuiBackdrop-root": {
      color: " #fff",
      zIndex: "1201",
    },
    "& .MuiTable-root": {
      minWidth: 350,
      tableLayout: "fixed",
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
        wordBreak: "break-word",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "30px 25px",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
        "& .consignment": {
          width: "200px",
        },

        "& .weight": {
          width: "150px",
        },
        "& .quantity": {
          width: "150px",
        },
        "& .customer": {
          width: "150px",
        },
        "& .check": {
          width: "100px",
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "22px 25px",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .check": {
        width: "100px",
      },
      "& .weight": {
        width: "150px",
      },
      "& .quantity": {
        width: "150px",
      },
      "& .consignment": {
        width: "200px",
      },
      "& .action": {
        width: "140px",
      },
    },
  },
  dialogContentText: {
    fontWeight: "700",
    color: "#212121",
  },
  cellHeader: {
    fontWeight: "700",
  },
  tabHeadingRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "20px",
  },
  "& .btn-wrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    "& .primary-btn": {
      fontSize: "16px",
      fontWeight: "600",
      minWidth: "160px",
      lineHeight: "50px",
      textTransform: "uppercase",
      height: "50px",
      "@media (max-width: 574px)": {
        width: "100%",
      },
    },
  },
  searchWrapper: {
    maxWidth: "300px",
    flex: "0 0 300px",
    marginRight: "10px",
    "@media (max-width: 1001px)": {
      maxWidth: "190px",
      flex: "0 0 190px",
      marginBottom: "10px",
    },
    "@media (max-width: 1500px)": {
      maxWidth: "300px",
      flex: "0 0 300px",
    },
    "@media (max-width: 900px)": {
      flex: "0 0 100%",
      maxWidth: "100%",
    },
    "& .form-gourp": {
      backgroundColor: colors.white,
      "& .MuiOutlinedInput-adornedEnd": {
        padding: "0",
        position: "relative",
        "& img": {
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          right: "15px",
        },
      },
      "& input": {
        border: "solid 1px #e3e3e3",
        color: colors.light_black,
        letterSpacing: 0,
        backgroundColor: colors.white,
        padding: "0 35px 0 15px !important",
        height: "48px",
        lineHeight: "48px",
        "&::placeholder": {
          opacity: "0.5",
          color: colors.light_black,
        },
      },
    },
  },
  searchWrapper1: {
    maxWidth: "250px",
    flex: "0 0 250px",
    marginRight: "15px",
    display: "flex",
    "@media (max-width: 1001px)": {
      maxWidth: "190px",
      flex: "0 0 190px",
    },
    "@media (max-width: 1500px)": {
      maxWidth: "300px",
      flex: "0 0 300px",
    },
    "@media (max-width: 900px)": {
      flex: "0 0 100%",
      maxWidth: "100%",
      flexWrap: "wrap",
      display: "flex",
      marginTop: "10px",
    },
    "& .btn-wrapper": {
      display: "flex",
      alignItems: "center",
      marginTop: "10px",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      "& .primary-btn": {
        display: "flex",
        fontSize: "16px",
        fontWeight: "600",
        minWidth: "160px",
        lineHeight: "50px",
        textTransform: "uppercase",
        height: "50px",
        "@media (max-width: 1001px)": {
          width: "100%",
        },
        "@media (max-width: 574px)": {
          width: "100%",
          marginTop: "10px",
        },
      },
      "& .form-gourp": {
        marginRight: "15px",
        "& .MuiOutlinedInput-adornedEnd": {
          padding: "0",
          position: "relative",
          "& img": {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            right: "15px",
          },
        },
      },
    },
  },
  deleteButton : {
    "@media (max-width: 574px)": { 
      paddingBottom: "10px",
    },
  },
  fileInput: {
    display: "block",
    position: "relative",
    marginRight: "15px",
    maxWidth: "200px",
    backgroundColor: colors.white,
    "&:hover": {
      opacity: "0.4",
    },
    "@media (max-width: 574px)": {
      flex: "0 0 100%",
      maxWidth: "100%",
      marginRight: "10px",
      marginBottom: "10px",
    },
    "& .MuiFormControl-root": {
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      right: "0",
      left: "0",
      "& input": {
        cursor: "pointer",
        fontSize: "0",
      },
    },
    "& .label-block": {
      width: "100%",
      border: " 1px solid #e7e4f1",
      height: "50px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      padding: "0 15px",
      transition: "all 0.3s",
      lineHeight: "50px",
      borderRadius: "6px",
      cursor: "pointer",
      "& .file-name": {
        color: colors.primary,
        display: "block",
        fontWeight: "600",
        fontSize: "16px",
        marginLeft: "10px",
        lineHeight: "1.321",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textTransform: "uppercase",
      },
      "& img": {
        height: "20px",
        width: "20px",
      },
    },
  },
  openFileInputButton: {
    marginRight: "15px",
    maxWidth: "200px",
    backgroundColor: colors.white,
    "&:hover": {
      opacity: "0.4",
    },
    "& .label-block": {
      border: " 1px solid #e7e4f1",
      height: "50px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      padding: "0 15px",
      transition: "all 0.3s",
      lineHeight: "50px",
      borderRadius: "6px",
      cursor: "pointer",
      "& .file-name": {
        color: colors.primary,
        fontWeight: "600",
        fontSize: "16px",
        marginLeft: "10px",
        lineHeight: "1.321",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textTransform: "uppercase",
      },
      "& img": {
        height: "20px",
        width: "20px",
      },
    },
  },
  searchWrapperBulkImport: {
    maxWidth: "100%",
    marginBottom: "20px",
    "& .form-gourp": {
      backgroundColor: colors.white,
      "& input": {
        border: "solid 1px #e3e3e3",
        color: colors.light_black,
        letterSpacing: 0,
        backgroundColor: colors.white,
        padding: "0 35px 0 15px !important",
        height: "48px",
        lineHeight: "48px",
        "&::placeholder": {
          opacity: "0.5",
          color: colors.light_black,
        },
      },
    },
  },
  fileInputBulkImport: {
    maxWidth: "200px",
    backgroundColor: colors.white,
    "&.disable": {
      opacity: "0.5",
      pointerEvents: "none",
    },
    "&:hover": {
      opacity: "0.4",
    },
    "& .MuiFormControl-root": {
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      right: "0",
      left: "0",
      "& input": {
        cursor: "pointer",
        fontSize: "0",
      },
    },
    "& .label-block": {
      border: " 1px solid #e7e4f1",
      width: "100%",
      height: "50px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      padding: "0 15px",
      transition: "all 0.3s",
      lineHeight: "50px",
      borderRadius: "6px",
      cursor: "pointer",
      "& .file-name": {
        color: colors.primary,
        display: "block",
        fontWeight: "600",
        fontSize: "16px",
        marginLeft: "10px",
        lineHeight: "1.321",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textTransform: "uppercase",
      },
      "& img": {
        height: "20px",
        width: "20px",
      },
    },
  },
}));

const AddConsignmentStyle = makeStyles({
  AddConsignmentWrapper: {},
  customForm: {
    overflow: "hidden",
    "& textarea": {
      overflow: "auto !important",
      verticalAlign: "top",
      resize: "none",
      border: "1px solid #e7e4f1",
      borderRadius: "6px",
      padding: "10px 15px !important",
      minHeight: "90px",
      lineHeight: "1.321",
    },
    "& .form-row": {
      display: "flex",
      margin: "0 -10px",
      "@media (max-width: 575px)": {
        flexWrap: "wrap",
      },
      "& .form-group": {
        padding: "0 10px",
        maxWidth: "50%",
        flex: "0 0 50%",
        marginBottom: "20px",
        "@media (max-width: 575px)": {
          maxWidth: "100%",
          flex: "0 0 100%",
        },
        "&.full-width": {
          maxWidth: "100%",
          flex: "0 0 100%",
        },
        "&.three-column": {
          maxWidth: "33.33%",
          flex: "0 0 33.33%",
          "@media (max-width: 575px)": {
            maxWidth: "100%",
            flex: "0 0 100%",
          },
        },
        "& .label-text": {
          fontSize: "14px",
        },
        "& .error-text": {
          color: "red",
        },
        "& .info-icon": {
          position: "relative",
          top: "-3px",
          paddingLeft: "8px",
          cursor: "pointer",
          display: "inline-block",
        },
      },
      "& .checkbox-wrapper": {
        display: "flex",
        alignItems: "center",
        "& .custom-checkbox": {
          margin: 0,
        },
      },
    },
  },
  customModal: {
    "& .MuiDialog-paperWidthSm": {
      display: "block",
      boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "32px 40px 40px",
      maxWidth: "820px",
      width: "100%",
      "@media (max-width: 991px)": {
        maxWidth: "100%",
        padding: "20px 15px",
        margin: "30px 15px",
        width: "auto",
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "30px",
        "@media (max-width: 480px)": {
          marginBottom: "20px",
        },
      },
      "& .MuiDialogContent-root": {
        padding: "0",
        overflow: "hidden",
      },
      "& h2": {
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "40px",
        marginLeft: "10px",
      },
    },
    "& .close-modal": {
      position: "absolute",
      right: "40px",
      top: "40px",
      cursor: "pointer",
      "@media (max-width: 991px)": {
        top: "28px",
        right: "25px",
      },
    },
    "& .bottom-button-block": {
      padding: "15px 0 0",
      display: "flex",
      justifyContent: "space-between",
      "@media (max-width: 480px)": {
        flexDirection: "column",
      },
      "& button": {
        height: "50px",
        lineHeight: "50px",
        fontWeight: "600",
        fontSize: "16px",
        minWidth: "165px",
        textTransform: "uppercase",
        "@media (max-width: 480px)": {
          minWidth: "100%",
          marginBottom: "15px",
        },
      },
    },
  },
  customModalBulkImport: {
    "& .MuiDialog-paperWidthSm": {
      display: "block",
      boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "32px 40px 40px",
      maxWidth: "520px",
      width: "100%",
      "@media (max-width: 760px)": {
        maxWidth: "480px",
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "30px",
        "@media (max-width: 480px)": {
          marginBottom: "20px",
        },
      },
      "& .MuiDialogContent-root": {
        padding: "0",
        overflow: "hidden",
      },
      "& h2": {
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "40px",
      },
    },
    "& .close-modal": {
      position: "absolute",
      right: "40px",
      top: "40px",
      cursor: "pointer",
    },
    "& .btn-wrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    }
  },
  fileInput: {
    display: "block",
    position: "relative",
    "& .MuiFormControl-root": {
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      right: "0",
      left: "0",
      "& input": {
        cursor: "pointer",
        fontSize: "0",
      },
    },
    "& .label-block": {
      width: "100%",
      border: " 1px solid #e7e4f1",
      height: "50px",
      margin: 0,
      display: "flex",
      alignItems: "center",
      padding: "0 15px",
      transition: "all 0.3s",
      lineHeight: "50px",
      borderRadius: "6px",
      cursor: "pointer",
      "& .file-name": {
        color: colors.skyblue,
        display: "block",
        marginLeft: "10px",
        lineHeight: "1.321",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& img": {
        height: "20px",
        width: "20px",
      },
    },
  },
});

export { AddConsignmentStyle };

export { ConsignmentStyle };
